import _ from 'lodash';

// @TODO: remove this and transfer it to the goodsObject class since all the functions are only used with goodsObject.
export const standardFunctions : {[key: string]: any } = {
  sqmToKg: (sqmValue: any, goodsObject: any) => {
    return (sqmValue * _.get(goodsObject, 'density', 0))/1000;
  },
  kgToSQM: (kgValue: any, goodsObject: any) => {
    return (kgValue * 1000) / _.get(goodsObject, 'density', 0);
  },
  pcsToKg: (pcsValue: any, goodsObject: any) => {
    return pcsValue / goodsObject.perKgRatio.plA.value;
  },
  kgToPcs: (kgValue: any, goodsObject: any) => {
    return kgValue * goodsObject.perKgRatio.plA.value;
  },
  priceSqmToKg: (priceInSQM: any, goodsObject: any) => {
    return (priceInSQM * 1000) / goodsObject.density;
  },
  priceKgToSQM: (priceInKg: any, goodsObject: any) => {
    return (priceInKg * goodsObject.density) / 1000;
  }
}